<template>
  <v-menu
    v-model="open"
    top
    :right="placement === 'right'"
    :offset-x="placement === 'right'"
    :offset-y="placement !== 'right'"
    :nudge-top="placement === 'right' ? 0 : 4"
    :nudge-right="placement === 'right' ? nudge : 0"
    :min-width="width"
    :max-width="width"
    content-class="app-menu app-user-menu"
  >
    <template v-slot:activator="scope">
      <slot name="activator" v-bind="scope" />
    </template>
    <div class="app-user-menu__list" role="none">
      <div class="app-user-menu__who" role="none">
        <span class="app-user-menu__name">{{ name }}</span>
        <span v-if="role" class="app-user-menu__meta">{{ role }}</span>
      </div>
      <div class="app-menu__divider" role="separator"></div>
      <router-link to="/settings/profile" class="v-list-item app-menu__item" role="menuitem">
        <span class="app-menu__text">Mein Profil</span>
        <app-icon name="user" :size="14" class="app-user-menu__icon" />
      </router-link>
      <a
        :href="docsUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="v-list-item app-menu__item"
        role="menuitem"
      >
        <span class="app-menu__text">Kundendokumentation<span class="app-sr-only"> (öffnet in neuem Tab)</span></span>
        <app-icon name="external" :size="14" class="app-user-menu__external" />
      </a>
      <div class="app-menu__divider" role="separator"></div>
      <button type="button" class="v-list-item app-menu__item app-user-menu__logout" role="menuitem" @click="$emit('sign-out')">
        <span class="app-menu__text">Abmelden</span>
        <app-icon name="logout" :size="14" class="app-user-menu__icon" />
      </button>
    </div>
  </v-menu>
</template>

<script>
// Benutzermenü der Shell (Spezifikation 2.11/3.3, Stil wie das Export-Menü), vereinfacht (Kundenwunsch 12.10.2026):
// Kopf mit Name und Rolle (nur Anzeige) · Mein Profil (Icon user rechts) · Kundendokumentation (neuer Tab, Icon
// external rechts) ·
// Abmelden (rot, Icon logout rechts; Ereignis sign-out, die Shell meldet ab). Mandant und Mandantenwechsel stehen in der Systemleiste, Verbindung, Stand und Version in der
// Karte am WLAN-Symbol; die Bedienung (Maus/Touch) folgt der automatischen Erkennung. Auf dem Handy gibt es kein
// Benutzermenü (Mehr-Menü).
// placement 'right' (Standard, alle drei Navigationsformen): rechts neben dem Benutzerknopf ab der Blattkante, unten
// bündig mit dem Knopf (Breite 240); placement 'top': über dem Knopf.
// Slot activator ({ on, attrs, value }) wie bei v-menu; Einträge tragen v-list-item für die Pfeiltasten von v-menu.
import AppIcon from '../ui/AppIcon.vue';
import { DOCS_URL, roleLabel, userDisplayName } from '../../shell/navigation';
import { notePopup } from '../../shell/shellState';

export default {
  name: 'AppUserMenu',
  components: { AppIcon },
  props: {
    placement: { type: String, default: 'right' },
    width: { type: Number, default: 240 },
    // Abstand nach rechts (placement 'right'): Menü beginnt an der Kante der Rail
    nudge: { type: Number, default: 12 }
  },
  data() {
    return {
      open: false,
      docsUrl: DOCS_URL
    };
  },
  computed: {
    name() {
      return userDisplayName(this.$store.state.profile);
    },
    role() {
      const profile = this.$store.state.profile;
      return roleLabel(profile ? profile.role : null);
    }
  },
  watch: {
    open(value) {
      notePopup(value);
    }
  },
  beforeDestroy() {
    if (this.open) {
      notePopup(false);
    }
  }
};
</script>

<style scoped>
/* Breite, Fläche, Kante, Schatten, Einträge und Trennlinie kommen aus app-menu (bedienelemente.css); hier nur die
   Besonderheiten des Benutzermenüs. */
.app-menu .app-menu__item.app-user-menu__logout {
  color: var(--red);
  font-weight: 500;
}
.app-menu .app-user-menu__external,
.app-menu .app-user-menu__icon {
  flex: none;
  width: 14px;
  height: 14px;
  color: var(--ink-3);
}
/* Abmelden: Icon in der Farbe des Eintrags (rot) */
.app-menu .app-user-menu__logout .app-user-menu__icon {
  color: currentColor;
}
.app-user-menu__who {
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
}
.app-user-menu__name,
.app-user-menu__meta {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.app-user-menu__name {
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
  color: var(--ink);
}
.app-user-menu__meta {
  font-size: 12px;
  line-height: 16px;
  color: var(--ink-3);
}
</style>
